(function () {
    'use strict';

    angular.module('chilliAuth').constant('chilliAuthConstants', {
        DOMAIN: 'jbsun.au.auth0.com',
        CLIENT_ID: 'b9lPInmvUbdGeBgK8UByQFjLiQSl48eE',
        LOGIN_URL: '/login',
        POST_LOGIN_URL: '/dashboard',
        AUTH_SCOPE: 'openid app_metadata'
    });
})();